import type {
  DoubleRadius,
  DoubleSpacing,
  RadiusKey,
  SpacingKey,
} from './config/spacing';

type ThemeWithSpacing = { spacing: Record<string, string> };

export const spacingToStyle = (
  theme: ThemeWithSpacing,
  spacing?: DoubleSpacing,
) =>
  spacing
    ?.split(' ')
    .map(value => theme.spacing[value as SpacingKey])
    .join(' ') ?? 0;

export const radiusToStyle = (
  theme: ThemeWithSpacing,
  radius?: DoubleRadius | DoubleSpacing,
) => {
  if (!radius) {
    return '0';
  }
  const split = radius.split(' ');
  if (split.length === 1) {
    return theme.spacing[radius as RadiusKey];
  }
  return [split[0], split[0], split[1], split[1]]
    .map(value => theme.spacing[value as RadiusKey])
    .join(' ');
};
